

function AppRun(AppConstants, $rootScope, $transitions, $location, $cookies, User, $uiRouter, $translate, cfpLoadingBar, UserService, Auth, Configs, Idle, Keepalive, Modal, $state, UsersService, $timeout) {
  'ngInject';

  $transitions.onStart({}, (transition) => {
    cfpLoadingBar.start();
  });

  $transitions.onSuccess({}, (transition) => {
    cfpLoadingBar.complete();
  });

  $transitions.onSuccess({}, (transition) => {
    $timeout(() => {
      const searchInput = document.querySelector('.navbar-form.navbar-right input[type="text"].form-control');
      if (searchInput) {
        searchInput.focus();
      }
    }, 100);
  });

  document.addEventListener('click', (e) => {
    setTimeout(() => {
      const openLayer = document.querySelector('.checkboxLayer.show');
      if (!openLayer) return;
      if (openLayer.contains(e.target)) return;
      const openFilter = openLayer.querySelector('.inputFilter');
      if (openFilter && document.activeElement !== openFilter) {
        openFilter.focus();
      }
    }, 50);
  }, true);

  let requiredAuthCriteria = {
    to: (state) => state.data && state.data.requireLogin
  }

  let hasACLCriteria = {
    to: (state) => state.data && state.data.requireACL
  }

  let redirectToLogin = (transition) => {
    let AuthService = transition.injector().get('Auth');
    let $state = transition.router.stateService;
    let User = transition.injector().get('User')
    if (!AuthService.isAuthenticated()) {
      User.setPrevState(angular.copy(window.location))
      return $state.target('login', undefined)
    }
  }

  let invalidACL = (transition) => {

    let acl = transition.to().data.requireACL

    let User = transition.injector().get('User')
    let UserService = transition.injector().get('UserService')
    let BranchService = transition.injector().get('BranchService')
    let ScanConfigService = transition.injector().get('ScanConfigService')

    let $state = transition.router.stateService;
    let $q = transition.injector().get('$q')
    let requiredACL = transition.to().data.requireACL

    if (Auth.isAuthenticated()) {
      const userObj = User.getUser();

      if (userObj && userObj.branchId) {
        BranchService.getBranchSetup(userObj.branchId)
          .then((data) => {
            ScanConfigService.setScanConfig(data.prefixes);
            Configs.setEnvironmentConfig(data.environmentConfig);
          })
          .catch((err) => {
            console.log(err);
          })
      }

      if (!User.hasACL()) {
        // const userObj = User.getUser();
        return $q.all([
          UserService.acl(),
          // BranchService.getBranchSetup(userObj.branchId)
        ])
          .then((data) => {
            // ScanConfigService.setScanConfig(data[1].prefixes)
            return User.setACL(data[0])
          })
          .then(() => {
            if (!User.isAccessible(requiredACL)) {
              return $state.target('access_denied');
            }
          })
          .catch(() => {
            return $state.target('access_denied');
          })
      } else {
        if (!User.isAccessible(requiredACL)) {
          return $state.target('access_denied');
        }
      }
    }
  }

  $transitions.onBefore(requiredAuthCriteria, redirectToLogin, {
    priority: 10
  })

  $transitions.onBefore(hasACLCriteria, invalidACL, {
    priority: 1
  })

  $rootScope.globals = {
    user: $cookies.getObject('user')
  }

  $rootScope.$on('userChanged', (evt, user) => {
    if (user) {
      $cookies.putObject('user', user)
    } else {
      $cookies.remove('user')
    }
  })
  if ($rootScope.globals.user) {
    User.setUser($rootScope.globals.user)
    
    UsersService.get($rootScope.globals.user.id)
      .then((profile) => {
         User.setUser(profile);
         $rootScope.globals.user = profile;
         $cookies.putObject('user', profile);
      })
      .catch((err) => {
         console.log("Failed to sync profile status:", err);
      });

    // console.log('user\'s language', $rootScope.globals.user.languageId);
    // If user exist, check user preferred language
    setTimeout(() => {
      $translate.use($rootScope.globals.user.languageId)
    }, 0)
  }
  const sessionLength = JSON.parse(localStorage.getItem('sessionLength'));

  if (sessionLength && Auth.isAuthenticated()) {
    Idle.watch();
  }
  $rootScope.$on('IdleStart', function () {
    Modal.timeoutCountdown('', ({ modal }) => {
      modal.close();
    }, ({ modal }) => {
      if (modal) modal.close()
    })
  });

  $rootScope.$on('IdleTimeout', function () {
      localStorage.removeItem('user');
      localStorage.removeItem('loginTime');
      localStorage.removeItem('email');
      localStorage.removeItem('name');
      localStorage.removeItem('sessionLength');
      $cookies.remove('user');
      User.clearUser();
      Idle.unwatch();
      Auth.logout();
      window.location.href = '/login';
  });

  $rootScope.$on('Keepalive', function () {
    //Keep alive event
  });

}

export default AppRun;



// WEBPACK FOOTER //
// ./client/app/config/app.run.js